<div class="sticky-wrapper">
  <ng-template *ngTemplateOutlet="linksTemplate"> </ng-template>
</div>

@if (deviceService.isDesktop()) {
<div class="sticky-wrapper sticky" [class.visible]="showSticky">
  <div class="sticky-container">
    <h3>{{ title }}</h3>
    <ng-template *ngTemplateOutlet="linksTemplate"> </ng-template>
  </div>
</div>
}

<ng-template #linksTemplate>
  <div class="wrapper" #stickyLinkWrapper>
    @for (link of stickyLinks; track link.id) {
    <a [href]="link.link" target="_blank" rel="nofollow">
      <div class="img-container">
        <img [ngSrc]="'/titleSvgs/' + link.icon" [alt]="link.icon" width="20" height="20" />
      </div>
      <b>{{ link.text }}</b>
      <img
        class="arrow"
        [ngSrc]="'/icons/arrow-right.svg'"
        alt="arrow-right"
        width="15"
        height="15"
      />
    </a>
    }
  </div>
</ng-template>
